<template>
  <DataFetcher
    dataKey="deals"
    @fetched="initSlider"
    :emptyChecker="(data) => false"
  >
    <template #any="{ loading, loadingError, refresh, data }">
      <div class="py-2">
        <div
          class="relative py-[28%] disableClippedBg"
          :class="{
            '-mb-[15%]':
              loading ||
              loadingError ||
              !(
                (!Array.isArray(data) && !Array.isArray(data?.result)) ||
                (!data.length && !data?.result?.length)
              )
          }"
        >
          <!-- Loading State -->
          <div
            v-if="loading"
            class="absolute top-0 left-0 w-full overflow-auto flex justify-center"
          >
            <div class="flex w-max gap-6 mt-2">
              <div class="w-[80vw]">
                <div class="shimmerElement py-[26%]"></div>
              </div>
              <div class="w-[80vw]">
                <div class="shimmerElement py-[26%]"></div>
              </div>
              <div class="w-[80vw]">
                <div class="shimmerElement py-[26%]"></div>
              </div>
            </div>
          </div>

          <!-- Error State -->
          <div
            v-else-if="loadingError"
            class="absolute top-0 left-0 w-full h-full pb-[15%]"
          >
            <div
              class="h-full flex flex-col items-center justify-center cursor-pointer"
              @click="refresh"
            >
              <!-- illustration erreur -->
              <div class="relative w-24 h-24 mb-4">
                <!-- cercle de fond -->
                <div
                  class="absolute inset-0 rounded-full bg-gradient-to-br from-red-900/20 to-orange-900/10"
                ></div>
                <!-- icône central -->
                <div class="absolute inset-0 flex items-center justify-center">
                  <svg
                    class="w-12 h-12 text-red-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                    />
                  </svg>
                </div>
              </div>

              <!-- texte principal -->
              <div class="text-center">
                <div class="font-semibold text-lg text-red-300 mb-1">
                  Erreur de chargement
                </div>
                <div class="text-sm text-gray-500 mb-4">
                  Impossible de récupérer les deals
                </div>

                <!-- bouton de refresh -->
                <div
                  class="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-900/20 hover:bg-red-900/30 transition-colors"
                >
                  <svg
                    class="w-4 h-4 text-red-400"
                    :class="{ 'animate-spin': loading }"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                    />
                  </svg>
                  <span class="text-sm text-red-300">Réessayer</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Empty State -->
          <SectionEmptyState
            v-else-if="
              (!Array.isArray(data) && !Array.isArray(data?.result)) ||
              (!data.length && !data?.result?.length)
            "
            class="absolute top-0 left-0 w-full h-full pb-[15%]"
            title="Aucun deal disponible"
            description="Les meilleures offres des restaurants arrivent bientôt sur Rapidoo !"
            icon-type="deals"
            @refresh="refresh"
          />

          <!-- Deals Carousel with SwipperView -->
          <div v-else class="w-full h-full absolute left-0 top-0 mt-2">
            <SwipperView
              :slidesPerView="1.2"
              :nbTabs="
                (Array.isArray(data?.result)
                  ? data.result
                  : Array.isArray(data)
                    ? data
                    : [{}, {}, {}]
                ).length
              "
              :centeredSlides="true"
              :autoPlay="8105"
              :loop="true"
              :defaultTab="1"
              class="h-full"
            >
              <template #default="{ position }">
                <div class="w-full p-[25%] relative">
                  <div class="absolute top-0 left-0 w-full h-full">
                    <div class="px-2 relative w-full h-full">
                      <div class="relative w-full h-full">
                        <DealItem
                          :deal="
                            (Array.isArray(data?.result)
                              ? data.result
                              : Array.isArray(data)
                                ? data
                                : [{}, {}, {}])[position] || {}
                          "
                          small
                          :position="position"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </SwipperView>
          </div>
        </div>
        <div class="py-2"></div>
      </div>
    </template>
  </DataFetcher>
</template>

<style scoped>
.pubsContainerCliped {
  clip-path: polygon(0% 0%, 100% 0%, 100% 85%, 0% 100%);
}

.disableClippedBg .pubsContainerCliped {
  clip-path: none;
}

.shimmerElement {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
